import React, { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';

import { WizardFormHelpText } from '@futrli/ui-components/components/sidebar/wizard/wizard-form-help-text/wizard-form-help-text';
import { ForecastKindOption } from '../../../types';

interface ForecastFormHelpTextProps {
  kind: ForecastKindOption;
}

export const ForecastFormHelpText = ({ kind }: ForecastFormHelpTextProps) => {
  const urls: Record<ForecastKindOption, string> = {
    budget: `https://support.futrli.com/en/articles/8948041-create-a-forecast`,
    scenario: `https://support.futrli.com/en/articles/8948041-create-a-forecast`
  };

  const title = useMemo(() => {
    if (kind === 'budget') {
      return (
        <FormattedMessage
          id="predict.create_forecast.creating_a_pnl_budget_for_the_first_time"
          defaultMessage="Creating a P&L budget for the first time?"
        />
      );
    } else {
      return (
        <FormattedMessage
          id="predict.create_forecast.creating_a_3way_forecast_for_the_first_time"
          defaultMessage="Creating a 3-way forecast for the first time?"
        />
      );
    }
  }, [kind]);

  return (
    <WizardFormHelpText
      title={title}
      text={
        <FormattedMessage
          id="predict.create_forecast.click_here_for_help_getting_started"
          defaultMessage="{link} for help getting started"
          values={{
            link: (
              <a target="_blank" rel="noreferrer" href={urls[kind]}>
                <FormattedMessage id="predict.create_forecast.help_link.click_here" defaultMessage="Click here" />
              </a>
            )
          }}
        />
      }
    />
  );
};
